export const USERS_EMPLOYER_COMPANY_BANNER_UPLOAD_REQUEST =
  'users/employer-company-banner-upload-request'
export const USERS_EMPLOYER_COMPANY_BANNER_UPLOAD_SUCCESS =
  'users/employer-company-banner-upload-success'
export const USERS_EMPLOYER_COMPANY_BANNER_UPLOAD_FAILED =
  'users/employer-company-banner-upload-failed'
